import UserPanel from 'Container/UserPanel';
import Middlewares from "../middlewares/";

const HomeV1 = () => import(/* webpackChunkName: "home" */ 'Views/HomeV1');
const Functionalities = () => import(/* webpackChunkName: "functionalities" */ 'Views/Functionalities');
const CustomInvoice = () => import(/* webpackChunkName: "CustomInvoice" */ 'Views/CustomInvoice');
const Pricing = () => import(/* webpackChunkName: "pricing" */ 'Views/Pricing');
const PrivacyPolice = () => import(/* webpackChunkName: "pricing" */ 'Views/PrivacyPolicy');
const Business = () => import(/* webpackChunkName: "business" */ 'Views/Business');
const ContactUs = () => import(/* webpackChunkName: "contact" */ 'Views/Contact');
const Support = () => import(/* webpackChunkName: "support" */ 'Views/Support');
const Demo = () => import(/* webpackChunkName: "demo" */ 'Views/Demo');
const Login = () => import(/* webpackChunkName: "login" */ 'Views/Auth/Login.vue');

export default {
    path: '/',
    component: UserPanel,
    // redirect:'/home',
    children: [
        {
            path: '/',
            component: HomeV1,
            name: 'home',
        },
        {
			path: '/login',
			component: Login,
			name: 'login',
			meta: {
				middleware: [Middlewares.guest],
            }
		},
        {
            path: '/funcionalidades',
            component: Functionalities,
            meta: {
				middleware: [Middlewares.guest],
            }
        },
        {
            path: '/negocios',
            component: Business,
            meta: {
				middleware: [Middlewares.guest],
            }
        },
        {
            path: '/planes',
            component: Pricing,
            meta: {
				middleware: [Middlewares.guest],
            }
        },
        {
            path: '/mejora-tu-diseño',
            component: CustomInvoice,
            meta: {
				middleware: [Middlewares.guest],
            }
        },
        {
        	path: '/contactos',
        	component: ContactUs,
            name:'ContactUs',
            meta: {
				middleware: [Middlewares.guest],
            }
        },
        {
        	path: '/soporte',
        	component: Support,
            name:'Support',
            meta: {
				middleware: [Middlewares.guest],
            }
        },
        {
        	path: '/demo',
        	component: Demo,
            name:'Demo',
            meta: {
				middleware: [Middlewares.guest],
            }
        },
        {
        	path: '/politicas-de-privacidad',
        	component: PrivacyPolice,
            name:'PrivacyPolice',
            meta: {
				middleware: [Middlewares.guest],
            }
        },
    ],
};
